import React from 'react'
import { Paper } from '@mui/material'


export default function PeerReview() {
    return (
        <>
            <Paper>
                <div className="p-5">
                    <div>
                        <div>
                            <h3 className='text-uppercase'>Peer Review Policy</h3>
                        </div>
                    </div>



                    <div>
                        ISAR Publisher is dedicated to maintaining the highest standards of quality and integrity in scholarly publishing. The peer-review process is a fundamental aspect of ensuring the validity and significance of the research we publish. This policy outlines the principles and procedures governing the peer-review process.
                    </div>
                    <br />
                    <div>
                        <strong>
                            1. Purpose of Peer Review
                        </strong>
                    </div>
                    <div>
                        Peer review serves to:
                    </div>
                    <div>
                        <li>
                            Assess the originality, validity, and relevance of submitted manuscripts.
                        </li>
                        <li>
                            Provide authors with constructive feedback to improve their work.
                        </li>
                        <li>
                            Ensure that only high-quality research is published in our journals.</li>
                    </div>

                    <br />
                    <div>
                        <strong>2. Review Model</strong>
                    </div>
                    <div>
                        ISAR Publisher employs a <strong> double-blind peer review </strong> process, in which:
                    </div>

                    <div>
                        <li>
                            Reviewers do not know the identity of the authors.
                        </li>
                        <li>
                            Authors do not know the identity of the reviewers.
                        </li>
                    </div>
                    <div>
                        This ensures impartiality and minimizes potential bias.
                    </div>
                    <br />
                    <div>
                        <strong>3. Reviewer Selection</strong>
                    </div>
                    <div>
                        Reviewers are selected based on:
                    </div>
                    <div>
                        <li>
                            Their expertise in the subject area of the manuscript.
                        </li>
                        <li>
                            Their academic and/or professional experience.
                        </li>
                        <li>
                            Their past performance as reviewers, where applicable.
                        </li>
                    </div>
                    <div>
                        All reviewers are expected to follow ethical standards and declare any conflicts of interest.
                    </div>

                    <br />
                    <div>
                        <strong>
                            4. Review Criteria
                        </strong>
                    </div>

                    <div>
                        Reviewers evaluate manuscripts based on the following criteria:
                    </div>
                    <div>
                        <li>Originality and significance of the research.</li>
                        <li>
                            Clarity and coherence of the presentation.
                        </li>
                        <li>
                            Methodological soundness and accuracy of data analysis.
                        </li>
                        <li>
                            Relevance to the scope of the journal.
                        </li>
                        <li>
                            Proper citation of previous work.
                        </li>
                    </div>
                    <br />

                    <div>
                        <strong>5. Review Process</strong>
                    </div>
                    <div>
                        <li>
                            Each manuscript is reviewed by at least two independent reviewers.
                        </li>
                        <li>
                            Reviewers submit a detailed evaluation form with recommendations: Accept, Minor Revisions, Major Revisions, or Reject.
                        </li>
                        <li>
                            The editor makes the final decision based on the reviewers' comments and overall manuscript quality.
                        </li>
                    </div>

                    <br />
                    <div>
                        <strong>
                            6. Timelines
                        </strong>
                    </div>

                    <div>
                        ISAR Publisher is committed to maintaining an efficient and timely peer-review process. Authors will be promptly notified of editorial decisions and will receive constructive comments from reviewers to support the improvement of their manuscripts. We aim to ensure transparency and clear communication at every stage of the review.
                    </div>

                    <br />
                    <div>
                        <strong>
                            7. Confidentiality
                        </strong>
                    </div>
                    <div>
                        All manuscripts and related materials are treated as confidential. Reviewers and editors must not share, discuss, or disclose any manuscript content outside the review process.
                    </div>
                    <br />

                    <div>
                        <strong>
                            8. Ethical Considerations
                        </strong>
                    </div>

                    <div>
                        ISAR Publisher follows COPE (Committee on Publication Ethics) guidelines in all aspects of peer review and publication ethics. We encourage transparency, accountability, and integrity throughout the process.
                    </div>

                    <br />
                    <br />
                    <div>
                        <strong>
                            Continuous Improvement
                        </strong>
                    </div>
                    <div>
                        We continually strive to enhance the effectiveness and transparency of our peer-review process. Feedback from authors, reviewers, and readers is welcomed and considered for ongoing improvements.
                    </div>

                    <br />
                    <div>
                        For any inquiries or concerns related to the peer-review process, please contact our editorial team at [contact@isarpublisher.com].
                    </div>
                    <br />
                    <div>
                        This Peer Review Policy reflects our commitment to maintaining the highest standards of scholarly publishing and ensuring the quality and integrity of the research published in ISAR Publisher.
                    </div>

                </div>

            </Paper>
            </>
    )
}